import * as React from 'react';

/**
 * Компонент-обёртка для мемоизации компонентов внутри неё
 * */
export var MemoWrap = /*#__PURE__*/React.memo(function MemoizedChildren(_ref) {
  var children = _ref.children;
  return children;
});